import Tab from '@mui/material/Tab';
import Tabs, { type TabsProps } from '@mui/material/Tabs';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import type { CLevelSynthesisViewMode } from '../../types/primes';

export type CLevelSynthesisViewTabsProps = {
  value: CLevelSynthesisViewMode;
  onChange: (value: CLevelSynthesisViewMode) => void;
};

const CLevelSynthesisViewTabs = ({ value, onChange }: CLevelSynthesisViewTabsProps) => {
  const { t } = useTranslation(['primes']);

  return (
    <StyledTabs
      value={value}
      onChange={(_event: Parameters<NonNullable<TabsProps['onChange']>>[0], nextValue: CLevelSynthesisViewMode) =>
        onChange(nextValue)
      }
      aria-label={t('clevelSynthesisTabMarge')}
    >
      <Tab value="marge" label={t('clevelSynthesisTabMarge')} />
      <Tab value="prime" label={t('clevelSynthesisTabPrimes')} />
    </StyledTabs>
  );
};

export default CLevelSynthesisViewTabs;

const StyledTabs = styled(Tabs)(({ theme }) => ({
  minHeight: theme.spacing(5),
  '& .MuiTab-root': {
    minHeight: theme.spacing(5),
    textTransform: 'none',
    fontWeight: 600,
  },
}));
